import { Adapter as a } from "../../../adapter.js";
import { GoogleTagManagerModel as r } from "./googleTagManager.model.js";
class s extends a {
  adapt(e) {
    return new r({
      status: e.status,
      containerId: e.container_id
    });
  }
  serialize(e) {
  }
}
export {
  s as GoogleTagManagerAdapter
};
//# sourceMappingURL=googleTagManager.adapter.js.map
